import * as React from 'react';

import "./social-dashboard.scss";

import {cs}                     from "@Common/react/chain-services";
import {consumeContext}         from "@Common/react/context";
import {Load2}                  from "@Common/react/load2";
import {UseState}               from "@Common/react/use-state";
import {SocialDashboardTable}   from './social-dashboard-table/social-dashboard-table';

export const SocialDashboard = ({idEntity, socialMediaStatus}) => cs(
    consumeContext("apis"), 
    ["filteredData", ({apis}, next) => Load2({
        fetch: () => apis.next.social.getAllPosts({idEntity})
            .then((data) => data.filter(datum => socialMediaStatus[datum.shareSite.toLowerCase()])),
        next,
    })],
    ["sortColumn", (_, next) => UseState({next, initValue: "dateShared"})],
    ["sortAscending", (_, next) => UseState({next, initValue: false})],
    ({filteredData, sortColumn, sortAscending}) => (
        <div className='social-dashboard-FeCN6'>
            <SocialDashboardTable data={filteredData} sortColumn={sortColumn} sortAscending={sortAscending} /> 
        </div>
    )
);